Shopify.formatMoney = function (cents, format = Shopify.money_format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class TemplateEngine {
  static render(template, data, html = false) {
    let result = template;
    Object.keys(data).forEach((key) => {
      const regex = new RegExp(`{#\\s*${key}\\s*#}`, "g");
      result = result.replace(regex, data[key] || "");
    });

    if (html) {
      return result.trim();
    }

    const templateElement = document.createElement("template");
    templateElement.innerHTML = result.trim();

    return templateElement.content.cloneNode(true);
  }
}

class WIQQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.addButton = this.querySelector("button[data-add-to-box]");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button:not([data-add-to-box])").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
    if (this.addButton) {
      this.addButton.addEventListener(
        "click",
        this.onAddButtonClick.bind(this)
      );
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector("button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }

  getValue() {
    return parseInt(this.input.value);
  }

  onAddButtonClick(event) {
    event.preventDefault();
    this.input.value = 1;
    this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("wiq-quantity-input", WIQQuantityInput);

class WIQRemoveItem extends HTMLButtonElement {
  constructor() {
    super();
    this.itemId = this.dataset.removeItem;
    this.removeListener = this.onRemoveClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.removeListener);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.removeListener);
  }

  onRemoveClick(event) {
    event.preventDefault();
    this._dispatchEvent();
  }
  _dispatchEvent() {
    document.dispatchEvent(
      new CustomEvent("wiq:item-change", {
        detail: {
          itemId: this.itemId,
          quantity: 0,
        },
      })
    );
  }
}
customElements.define("wiq-remove-item", WIQRemoveItem, { extends: "button" });

class WIQBoxItem extends HTMLElement {
  constructor() {
    super();
    this.itemId = this.dataset.itemId;
    this.inputQuantity = this.querySelector("wiq-quantity-input");
    this.templateHtml = this.querySelector("template").innerHTML;
    this.flavorList = JSON.parse(this.dataset.flavors || "[]").map((item) =>
      item.trim()
    );
  }
  connectedCallback() {
    this.inputQuantity.addEventListener(
      "change",
      this.onInputQuantityChange.bind(this)
    );
  }
  onInputQuantityChange(event) {
    event.preventDefault();
    const value = this.inputQuantity.getValue();
    if (value > 0) {
      this.setAttribute("data-active", "");
    } else {
      this.removeAttribute("data-active");
    }
    this._dispatchEvent();
  }

  _dispatchEvent() {
    document.dispatchEvent(
      new CustomEvent("wiq:item-change", {
        detail: {
          itemId: this.itemId,
          quantity: this.inputQuantity.getValue(),
        },
      })
    );
  }

  getHtml(quantity) {
    if (quantity != this.inputQuantity.getValue()) {
      this.inputQuantity.input.value = quantity;
      if (quantity > 0) {
        this.setAttribute("data-active", "");
      } else {
        this.removeAttribute("data-active");
      }
    }
    return TemplateEngine.render(
      this.templateHtml,
      {
        quantity: quantity,
      },
      true
    );
  }
}
customElements.define("wiq-box-item", WIQBoxItem);

class WIQBuildBox extends HTMLElement {
  constructor() {
    super();
    this.selectedItems = [];
    this.totalItemCount = 0;
    this.selectedVariant = null;
    this.selectedVariantInput = null;
    this.selectedGiftVariantInput = null;
    this.packSize = 0;
    this.selectedItemsContainer = this.querySelector("[data-selected-items]");
    this.onBoxChange = this.onBoxChange.bind(this);
    this.variantInputs = Array.from(
      this.querySelectorAll('input[name="wiq-variant"]')
    );
    this.giftVariantInputs = Array.from(
      this.querySelectorAll('input[name="gift-option"]')
    );

    this.variantTitleEl = this.querySelector("[data-selected-variant]");
    this.variantPriceEl = this.querySelector("[data-selected-variant-price]");
    this.addCartButton = this.querySelector("[data-wiq-add-to-cart]");
    this.totalItemCountEl = this.querySelector("[data-total-item-count]");
    this.packSizeEl = this.querySelector("[data-pack-size]");
    this.mobileViewOpener = this.querySelector("[data-view-bundle-cart]");
    this.keepShoppingButton = this.querySelectorAll("[data-keep-shopping]");
    this.hideGiftOptions = false;
  }
  connectedCallback() {
    this.onVariantChange();
    document.addEventListener("wiq:item-change", this.onBoxChange);
    this.variantInputs.forEach((input) => {
      input.addEventListener("change", this.onVariantChange.bind(this));
    });
    this.addCartButton.addEventListener("click", this.addToCart.bind(this));
    this.giftVariantInputs.forEach((input) => {
      input.addEventListener("change", this.onGiftVariantChange.bind(this));
    });
    this.mobileViewOpener.addEventListener("click", () => {
      this.setAttribute("data-mobile-cart-drawer", "");
    });
    this.keepShoppingButton.forEach((button) => {
      button.addEventListener("click", () => {
        this.removeAttribute("data-mobile-cart-drawer");
      });
    });
  }

  onVariantChange() {
    this.selectedVariantInput = this.variantInputs.find(
      (input) => input.checked
    );
    if (this.selectedVariantInput) {
      this.selectedVariant = this.selectedVariantInput.value;
      this.packSize = parseInt(this.selectedVariantInput.dataset.count);
      this.variantTitleEl.textContent =
        this.selectedVariantInput.dataset.variantTitle;
      this.packSizeEl.textContent = this.packSize;

      this.hideGiftOptions =
        this.selectedVariantInput.dataset.hideGiftOptions == "true";

      if (this.totalItemCount > this.packSize) {
        this.handlePackSizeReduced();
      }
      if (this.hideGiftOptions) {
        this.setAttribute("data-gift-hidden", "");
      } else {
        this.removeAttribute("data-gift-hidden");
      }

      this.updatePrice();
      this.packLimitCheck();
    }
  }
  onGiftVariantChange() {
    this.selectedGiftVariantInput = this.giftVariantInputs.find(
      (input) => input.checked
    );

    this.updatePrice();
  }

  updatePrice() {
    var total = 0;
    if (this.selectedVariantInput) {
      total += parseInt(this.selectedVariantInput.dataset.variantPrice);
    }
    if (
      this.selectedGiftVariantInput &&
      this.selectedGiftVariantInput.value != "none" &&
      !this.hideGiftOptions
    ) {
      total += parseInt(this.selectedGiftVariantInput.dataset.variantPrice);
    }
    this.variantPriceEl.textContent = Shopify.formatMoney(total);
  }

  onBoxChange(event) {
    event.preventDefault();
    const { itemId, quantity } = event.detail;
    const item = this.querySelector(`wiq-box-item[data-item-id="${itemId}"]`);
    if (quantity == 0) {
      this.selectedItems = this.selectedItems.filter(
        (item) => item.itemId != itemId
      );
      item.removeAttribute("data-active");
    } else {
      const existingItemIndex = this.selectedItems.findIndex(
        (item) => item.itemId == itemId
      );
      if (existingItemIndex !== -1) {
        this.selectedItems[existingItemIndex] = {
          itemId,
          quantity,
          item,
        };
      } else {
        this.selectedItems.unshift({
          itemId,
          quantity,
          item,
        });
      }
    }
    this.totalItemCount = this.selectedItems.reduce(
      (acc, item) => acc + item.quantity,
      0
    );

    this.packLimitCheck();
    this.render();
    this.updatePrice();

    console.log(this.selectedItems);
  }

  render() {
    this.totalItemCountEl.textContent = this.totalItemCount;
    if (this.selectedItems.length == 0) {
      this.selectedItemsContainer.innerHTML = "";
      this.setAttribute("data-empty-state", "");
      return;
    }
    this.removeAttribute("data-empty-state");
    var html = [];
    this.selectedItems.forEach((item) => {
      html.push(item.item.getHtml(item.quantity));
    });
    this.selectedItemsContainer.innerHTML = html.join("");
  }

  packLimitCheck() {
    if (this.totalItemCount == this.packSize) {
      this.addCartButton.removeAttribute("disabled");
      this.setAttribute("data-limit-reached", "");
    } else {
      this.addCartButton.setAttribute("disabled", "");
    }
    if (this.totalItemCount < this.packSize) {
      this.removeAttribute("data-limit-reached");
    }
  }

  handlePackSizeReduced() {
    let total = 0;
    let newSelectedItems = [];
    for (let i = 0; i < this.selectedItems.length; i++) {
      let item = this.selectedItems[i];
      if (total >= this.packSize) {
        item.item.removeAttribute("data-active");
        continue;
      }
      let allowed = Math.min(item.quantity, this.packSize - total);
      if (allowed > 0) {
        newSelectedItems.push({
          ...item,
          quantity: allowed,
        });

        total += allowed;
      }
    }
    this.selectedItems = newSelectedItems;

    this.totalItemCount = this.selectedItems.reduce(
      (acc, item) => acc + item.quantity,
      0
    );
    this.render();
  }

  addToCart(event) {
    event.preventDefault();
    var properties = {};
    const item = [];

    this.selectedItems.forEach((item, index) => {
      properties[
        `Item${index + 1}`
      ] = `${item.item.dataset.itemTitle} x ${item.quantity}`;
    });

    item.push({
      id: this.selectedVariant,
      quantity: 1,
      properties: properties,
    });

    if (
      this.selectedGiftVariantInput &&
      this.selectedGiftVariantInput.value != "none" &&
      !this.hideGiftOptions
    ) {
      item.push({
        id: this.selectedGiftVariantInput.value,
        quantity: 1,
        parent_id: this.selectedVariant,
      });
    }

    this.addCartButton.setAttribute("disabled", "");
    this.addCartButton.setAttribute("data-loading", "");

    fetch(`${window.Theme.routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: item,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.href = window.Theme.routes.cart_url;
      })
      .finally(() => {
        this.addCartButton.removeAttribute("disabled");
        this.addCartButton.removeAttribute("data-loading");
      });
  }
}
customElements.define("wiq-build-box", WIQBuildBox);

class WIQFilter extends HTMLElement {
  constructor() {
    super();
    this.selectedFilter = [];
    this.filtersItems = this.querySelectorAll("[data-filter-flavor]");
    this.allFilter = this.querySelector("[data-filter-flavor='all']");
  }
  connectedCallback() {
    this.filtersItems.forEach((item) => {
      item.addEventListener("click", this.onFilterClick.bind(this));
    });
  }

  onFilterClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const value = target.dataset.filterFlavor;
    if (value == "all") {
      this.filtersItems.forEach((item) => {
        if (item.dataset.filterFlavor == "all") {
          item.setAttribute("data-filter-active", "");
        } else {
          item.removeAttribute("data-filter-active");
        }
      });
    } else {
      this.allFilter.removeAttribute("data-filter-active");
      target.toggleAttribute("data-filter-active");
    }
    this._dispatchEvent();
  }
  _dispatchEvent() {
    this.selectedFilter = [];
    this.querySelectorAll("[data-filter-flavor][data-filter-active]").forEach(
      (item) => {
        this.selectedFilter.push(item.dataset.filterFlavor.trim());
      }
    );
    this.selectedFilter = this.selectedFilter.filter((item) => item != "all");

    this.buildBox = this.buildBox || this.closest("wiq-build-box");
    this.gridItems =
      this.gridItems || this.buildBox.querySelectorAll("wiq-box-item");

    if (this.selectedFilter.length == 0) {
      this.allFilter.setAttribute("data-filter-active", "");
      this.gridItems.forEach((item) => {
        item.removeAttribute("hidden");
      });
      return;
    }

    this.gridItems.forEach((item) => {
      const hasAllFlavors = this.selectedFilter.every((flavor) =>
        item.flavorList.includes(flavor)
      );

      if (hasAllFlavors) {
        item.removeAttribute("hidden");
      } else {
        item.setAttribute("hidden", "");
      }
    });
  }
}
customElements.define("wiq-filter", WIQFilter);

